import React, { useEffect } from 'react';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import './Location.css';
import { Link } from 'react-router-dom';
import imagePlaceHolder from "./../../images/building-icon.jpg"
import detail1 from "./../../images/location1.jpg";
import detail2 from "./../../images/location2.jpg";
import detail3 from './../../images/location3.jpg';
import detail5 from './../../images/location5.jpg';
import detail6 from './../../images/location6.jpg';
import detail8 from './../../images/location8.jpg';
import detail9 from './../../images/location9.jpg';
import detail10 from './../../images/location10.jpg';
import location from "./../../images/location.png";
import useNavigation from '../../utils/Navigation';

function Location() {
	useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

	  const navigateToSection = useNavigation()
  return (
    <>
      <Header />
      
<section>
	<div className='faq_banner'><p>Site locations</p></div>
	<div className='location'>  
	<div className='container'>
<div className='col-12'>
	<div className="row">
			<p>Clinical Trial Sites</p>
			<h3>Study Locations</h3>
			<div className="col-12 col-sm-6 loc_details">
				<div className="col-12 col-md-5"><img src={detail1} className="img-fluid" alt="..."/></div>
				<div className="col-12 col-md-7"><h6>Site 1 - London, United Kingdom</h6>
				{/* <p><img src={location} alt="Royal Brompton Hospital" className='loc'/> Dovehouse St, London SW3 6JY, United Kingdom</p> */}
				</div>
			</div>
			<div className="col-12 col-sm-6 loc_details">
				<div className="col-12 col-md-5"><img src={detail2} className="img-fluid" alt="..."/></div>
				<div className="col-12 col-md-7"><h6>Site 2 - Edinburgh, UK</h6>
				{/* <p><img src={location} alt="Royal Infirmary of Edinburgh" className='loc'/>51 Little France Crescent, Respiratory Medicine, 2nd Floor, Room S1634, Edinburgh, UK EH16 4SA</p> */}
				</div>
			</div>
			<div className="col-12 col-sm-6 loc_details">
				<div className="col-12 col-md-5"><img src={detail3} className="img-fluid" alt="..."/></div>
				<div className="col-12 col-md-7"><h6>Site 3 - Cottingham, East Yorkshire</h6>
				{/* <p><img src={location} alt="" className='loc'/> Castle Hill Hospital, Entrance 2, Castle Road, Daisy Building, 1st floor, Cottingham, East Yorkshire HU16 5JQ</p> */}
				</div>
			</div>
			
			<div className="col-12 col-sm-6 loc_details">
				<div className="col-12 col-md-5"><img src={detail5} className="img-fluid" alt="..."/></div>
				<div className="col-12 col-md-7"><h6>Site 4 - Manchester</h6>
				{/* <p><img src={location} alt="" className='loc'/> Southmoor Road; NIHR Manchester Clinical Research Facility at Wythenshawe Hospital Manchester University NHS Foundation Trust, Manchester M23 9LT</p> */}
				</div>
			</div>
			<div className="col-12 col-sm-6 loc_details">
				<div className="col-12 col-md-5"><img src={detail6} className="img-fluid" alt="..."/></div>
				<div className="col-12 col-md-7"><h6>Site 5 - Norwich Norfolk</h6>
				{/* <p><img src={location} alt="" className='loc'/> Colney Lane, Norwich Norfolk NR4 7UY</p> */}
				</div>
			</div>
			
			<div className="col-12 col-sm-6 loc_details">
				<div className="col-12 col-md-5"><img src={detail8} className="img-fluid" alt="..."/></div>
				<div className="col-12 col-md-7"><h6>Site 6 - Southampton</h6>
				{/* <p><img src={location} alt="" className='loc'/>Tremona Road, Southampton SO16 6YD</p> */}
				</div>
			</div>
			
			<div className="col-12 col-sm-6 loc_details">
				<div className="col-12 col-md-5"><img src={detail10} className="img-fluid" alt="..."/></div>
				<div className="col-12 col-md-7"><h6>Site 7 - Londonderry</h6>
				{/* <p><img src={location} alt="" className='loc'/>Altnagelvin Area Hospital Trust: Western Health And Social Care Trust, Londonderry, County Londonderry BT47 6SB</p> */}
				</div>
			</div>
			<div className="col-12 col-sm-6 loc_details">
				<div className="col-12 col-md-5"><img src={detail9} className="img-fluid" alt="..."/></div>
				<div className="col-12 col-md-7"><h6>Site 8 - Nottinghamshire</h6>
				{/* <p><img src={location} alt="" className='loc'/>Hucknall Road, Nottingham Nottinghamshire NG5 1PB</p> */}
				</div>
			</div>
			<div className="col-12 col-sm-6 loc_details">
				<div className="col-12 col-md-5"><img src={imagePlaceHolder} className="img-fluid" alt="..."/></div>
				<div className="col-12 col-md-7"><h6>Coming Soon</h6>
				{/* <p><img src={location} alt="" className='loc'/>Coming Soon...</p> */}
				</div>
			</div>
			
			<div className="col-12 col-sm-6 loc_details">
				<div className="col-12 col-md-5"><img src={imagePlaceHolder} className="img-fluid" alt="..."/></div>
				<div className="col-12 col-md-7"><h6>Coming Soon</h6>
				{/* <p><img src={location} alt="" className='loc'/> Coming Soon...</p> */}
				</div>
			</div>
	</div>
	{/* <div className="col-12 col-sm-6">
		<div className="map">
			<iframe title="google_maps" src="https://www.google.com/maps/d/u/0/embed?mid=1EFvQS3j7ouQN_dJDP_GeUF8m0on9xeI&ehbc=2E312F&noprof=1"> &nbsp;</iframe>
		</div>
	</div> */}
</div>

</div>
	</div>
</section>

      <section className="goal bg_green no_bg">
        <div className="container">
          <div className="faq">
            <h4>Explore FAQs to learn more about the clinical trial</h4>
            <Link to="/faqs" alt="faqs"><button className="explore">Explore</button></Link>
          </div>
        </div>
      </section>
	  <Link to = "/#eligibility"  onClick={() => navigateToSection('eligibility')} alt="sticky button"><button className="sticky_eligibility">See if you qualify</button></Link>
      <Footer />
    </>
  );
}

export default Location;